import { MobileDesktopNote, MobileHeader, MobileScreen } from '../../mobile';
import { useTranslation } from '../../i18n';

/**
 * «تنظیمات» on a phone: the statement that it is not here.
 *
 * The screen had a full phone surface — seven sections, a `MobileSectionNav`,
 * its own form sheets — and it is gone. «تنظیمات» is the deprecated tier: the
 * desktop panel never linked to it, and every part of it that a clinic actually
 * operates has moved to «کلینیک من» (مشخصات, واتس‌اپ, اعلان‌ها, قالب‌های پیام) or
 * to the account app (زبان و ترجیحات, at `/preferences`). What is left — the
 * profile picture, a pointer to the language, the WhatsApp link — is reachable
 * elsewhere on a phone, so nothing here is worth a second surface.
 *
 * So the surface goes and the sheet row with it. What does NOT go is the
 * answer: a bookmark, a shared link or a typed URL still lands somewhere that
 * says where the work happens, because `MobileDesktopNote`'s own rule is that a
 * capability is never SILENTLY missing — an operator who cannot find a thing
 * they used yesterday assumes the app is broken and files a bug about a
 * decision. See docs/MOBILE-REDESIGN.md §2.4 rule 4.
 *
 * It is also what the route-level skeleton renders for `/settings` on a phone.
 * There is nothing to wait for here, so the placeholder and the finished screen
 * are the same thing, and the fallback cannot flash the desktop shell at a
 * 360px viewport on its way past.
 */
export default function SettingsDesktopOnly() {
  const { t } = useTranslation();
  return (
    <MobileScreen
      data-testid="settings-mobile"
      data-state="desktop-only"
      header={(
        <MobileHeader
          title={t('settings.title')}
          onBack={() => window.history.back()}
          backLabel={t('common.actions.back')}
          data-testid="settings-mobile-header"
        />
      )}
    >
      <div style={{ padding: '0.875rem 1rem' }}>
        <MobileDesktopNote
          what={t('operations.desktopOnly.settings')}
          data-testid="settings-desktop-note"
        />
      </div>
    </MobileScreen>
  );
}
